import {
  AHB_MESSAGE_TYPE,
  AHB_PROCEDURE_ID,
  AHB_SUBPROCEDURE,
  AHB_VERSION,
  AHB_WITHDRAW_REASON,
} from "core/consts";
import { z } from "zod";
import { AHBdateSchema, AHBtimeSchema, IKNumberSchema } from "./shared";

export const AHBWithdrawalSchema = z.object({
  Nutzdaten: z.object({
    "@xmlns": z.string(),
    "@xmlns:gdb": z.string(),
    "@xmlns:aar": z.string(),
    "@xmlns:arh": z.string(),
    "@xmlns:feh": z.string(),
    "@xmlns:sto": z.string(),

    Header: z.object({
      "gdb:Absender": z.object({
        "gdb:Krankenhaus": z.object({
          "gdb:Institutionskennzeichen": IKNumberSchema,
        }),
      }),
      "gdb:Empfaenger": z.object({
        "gdb:Krankenkasse": z.object({
          "gdb:Institutionskennzeichen": IKNumberSchema,
        }),
      }),
      "gdb:Erstellungsdatum": AHBdateSchema,
      "gdb:Erstellungszeit": AHBtimeSchema,
      "gdb:Datei_ID": z.string().uuid(),
      "gdb:Verfahrenskennung": z.nativeEnum(AHB_PROCEDURE_ID),
      "gdb:Unterverfahren": z.literal(AHB_SUBPROCEDURE),
      "gdb:Nachrichtentyp": z.literal(AHB_MESSAGE_TYPE.WITHDRAWAL),
      "gdb:Logische_Version": z.nativeEnum(AHB_VERSION),
      // "gdb:Dateinummer": ahbDateinummerSchema, #TODO check if required
    }),

    Body: z.object({
      Stornonachricht: z.object({
        "sto:Datei_ID": z.string().uuid(),
        "sto:Begruendung": z
          .object({
            "sto:Grund": z.nativeEnum(AHB_WITHDRAW_REASON),
            "sto:Erlaeuterung": z.string().max(600).optional().nullable(),
          })
          .superRefine((data, ctx) => {
            if (data["sto:Grund"] === AHB_WITHDRAW_REASON.OTHER) {
              if (
                !data["sto:Erlaeuterung"] ||
                data["sto:Erlaeuterung"].trim() === ""
              ) {
                ctx.addIssue({
                  path: ["sto:Erlaeuterung"],
                  code: z.ZodIssueCode.custom,
                  message:
                    'Erläuterung is required when Grund is "9 - Sonstiges".',
                });
              }
            }
          }),
      }),
    }),
  }),
});
